/**
 * Returns property nested in object structure specified by propertyString
 * @param object {Object}
 * @param propertyString {string}
 * @returns {*}
 */
function unfold(object, propertyString) {
    const path = [...propertyString.matchAll(/\w+/g)].map(item=> item[0]);
    let result = object;
    for (const step of path) {
        if (result === undefined || result[step] === undefined) {
            return undefined;
        } else if (result[step] === null) {
            return  null;
        }
        result = result[step];
    }
    return result;
}

/**
 * Removes all properties with undefined values from an object.
 * @param obj {Object} - The object to remove undefined properties from.
 * @returns {Object} - A new object with all undefined properties removed.
 * @recursive
 */
function removeUndefined(obj) {
    return Object.keys(obj).reduce(function (accumulator, key) {
        const isObject = obj[key] !== null && typeof obj[key] === "object";
        let value = isObject ? removeUndefined(obj[key]) : obj[key];
        if (Array.isArray(obj[key])) {
            value = Object.values(value);
        }
        return value === undefined ? accumulator : Object.assign(accumulator, { [key]: value });
    }, {});
}

export {unfold, removeUndefined}
